export default function Hero() {
  return (
    <section className="relative min-h-screen flex items-center justify-center overflow-hidden">
      {/* Background Image */}
      <div className="absolute inset-0">
        <img
          src="https://public.readdy.ai/ai/img_res/6eb7648df2769a292a152108ccc1126a.jpg"
          alt="Legal Cybersecurity"
          className="w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/70 via-black/60 to-black/70"></div>
      </div>

      {/* Content */}
      <div className="relative z-10 max-w-7xl mx-auto px-6 py-32 text-center w-full">
        <div className="inline-flex items-center bg-[#e10708]/20 backdrop-blur-sm border border-[#e10708]/30 rounded-full px-6 py-3 mb-8">
          <i className="ri-alert-line text-[#e10708] text-xl mr-2 w-5 h-5 flex items-center justify-center"></i>
          <span className="text-white text-sm font-medium">Texas SB 2610 Compliance Required</span>
        </div>

        <h1 className="text-5xl lg:text-7xl font-serif text-white leading-tight mb-6">
          Texas SB 2610<br />
          Cybersecurity Safe Harbor Law
        </h1>

        <p className="text-xl lg:text-2xl text-white/90 max-w-3xl mx-auto mb-8 leading-relaxed">
          Protect your law firm from penalties up to <strong className="text-[#e10708]">$500,000</strong> with comprehensive cybersecurity compliance solutions designed specifically for Texas attorneys.
        </p>

        <div className="flex flex-col sm:flex-row items-center justify-center gap-4 mb-12">
          <button
            onClick={() => {
              const element = document.getElementById('contact');
              if (element) {
                element.scrollIntoView({ behavior: 'smooth' });
              }
            }}
            className="bg-[#e10708] text-white px-8 py-4 rounded-full text-base font-bold hover:bg-[#c10607] hover:shadow-xl hover:shadow-[#e10708]/30 transition-all duration-300 whitespace-nowrap cursor-pointer"
          >
            Schedule Compliance Assessment
          </button>
          <button
            onClick={() => {
              const element = document.getElementById('overview');
              if (element) {
                element.scrollIntoView({ behavior: 'smooth' });
              }
            }}
            className="bg-white/10 backdrop-blur-sm text-white border-2 border-white/30 px-8 py-4 rounded-full text-base font-bold hover:bg-white/20 transition-all duration-300 whitespace-nowrap cursor-pointer"
          >
            Learn More
          </button>
        </div>

        {/* Key Stats */}
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8 max-w-4xl mx-auto">
          <div className="bg-white/10 backdrop-blur-sm rounded-xl p-6 border border-white/20">
            <div className="text-[#e10708] text-4xl font-bold mb-2">Sept 1, 2025</div>
            <div className="text-white text-sm">Compliance Deadline</div>
          </div>
          <div className="bg-white/10 backdrop-blur-sm rounded-xl p-6 border border-white/20">
            <div className="text-[#e10708] text-4xl font-bold mb-2">$500K+</div>
            <div className="text-white text-sm">Potential Penalties</div>
          </div>
          <div className="bg-white/10 backdrop-blur-sm rounded-xl p-6 border border-white/20">
            <div className="text-[#e10708] text-4xl font-bold mb-2">100%</div>
            <div className="text-white text-sm">Our Compliance Rate</div>
          </div>
        </div>
      </div>
    </section>
  );
}